import React from 'react'
import { shallow } from 'enzyme'
import { Comment }  from '../../features/Commentary/Comment'

describe('Comment', () => {
  let wrapper, props, result, instance
  beforeEach(() => {
    props = {
      data: [
        {
          administrator: {
            rid: 123,
            name: 'SmartBiz Admin',
          },
          rid: 10,
          category: 'closing',
          content: 'testing content',
          state: 'published',
          replies: [
            {
              administrator: {
                rid: 123,
                name: 'SmartBiz Admin',
              },
              rid: 3,
              content: 'testing content',
            }
          ]
        }
      ],
      title: 'closing',
      createBankCommentary: () => {
        result = 'createBankCommentary'
      },
      updateBankCommentary: () => {
        result = 'updateBankCommentary'
      },
      createReply: () => {
        result = 'createReply'
      },
      updateReply: () => {
        result = 'updateReply'
      },
      loanId: 123,
      isBankUser: false,
    }

    wrapper = shallow(<Comment {...props} />)
    instance = wrapper.instance()
  })

  describe('#onSaveNewQuestion', () => {
    it('should call function', () => {
      const onSaveNewQuestion = spyOn(instance, 'onSaveNewQuestion')
      instance.onSaveNewQuestion({state: 'draft', editorContent: 'testing', files: null})
      expect(onSaveNewQuestion).toHaveBeenCalled()
    })
  })

  describe('#onNewReply', () => {
    it('should call function', () => {
      const onNewReply = spyOn(instance, 'onNewReply')
      instance.onNewReply({rid:123, draft:true, editorContent: 'testing', files: null})
      expect(onNewReply).toHaveBeenCalled()
    })
  })

  describe('#onUpdateReply', () => {
    it('should call function', () => {
      const onUpdateReply = spyOn(instance, 'onUpdateReply')
      instance.onUpdateReply({rid:123, draft:true, editorContent: 'testing', files: null, deleteFiles: null})
      expect(onUpdateReply).toHaveBeenCalled()
    })
  })

  describe('#onDeleteReply', () => {
    it('should call function and change the state', () => {
      const toggleDeleteModal = spyOn(instance, 'toggleDeleteModal')
      const renderDeleteConfirmation = spyOn(instance, 'renderDeleteConfirmation')
      const replyId = 123;
      instance.onDeleteReply({replyId})
      expect(toggleDeleteModal).toHaveBeenCalled()
      expect(renderDeleteConfirmation).toHaveBeenCalled()
      expect(wrapper.state('deleteReplyId')).toEqual(replyId)
    })
  })

  describe('#updateQuestions', () => {
    it('should call function and change the state', () => {
      const questions = wrapper.state('questions')
      const newQuestion = {
        rid: null,
        state: 'draft',
        category: props.title,
        content: "",
        createdAt: null,
        document: null,
        replies: [
        ]
      }
      questions.push(newQuestion)
      instance.updateQuestions(questions)
      expect(wrapper.state('questions').length).toEqual(2)
    })
  })

  describe('#addNewQuestion', () => {
    it('should call function', () => {
      const updateQuestions = spyOn(instance, 'updateQuestions')
      instance.addNewQuestion()
      expect(updateQuestions).toHaveBeenCalled()
      const newAddedQuestion = wrapper.state('questions').slice(-1).pop()
      expect(wrapper.state('questions').length).toEqual(2)
      expect(newAddedQuestion.document.files).toBeTruthy()
      expect(newAddedQuestion.document.files.length).toEqual(0)
    })
  })

  describe('#onDeleteQuestion', () => {
    it('should call function', () => {
      const toggleDeleteModal = spyOn(instance, 'toggleDeleteModal')
      const renderDeleteConfirmation = spyOn(instance, 'renderDeleteConfirmation')
      instance.onDeleteQuestion(props.data[0].rid)
      expect(toggleDeleteModal).toHaveBeenCalled()
      expect(renderDeleteConfirmation).toHaveBeenCalled()
      expect(wrapper.state('deleteQuestionId')).toEqual(props.data[0].rid)
    })
  })

  describe('#toggleDeleteModal', () => {
    it('should call function', () => {
      instance.toggleDeleteModal()
      expect(wrapper.state('isDeleteModalOpen')).toBeTruthy()
    })
  })

  describe('#onCloseClick', () => {
    it('should call function', () => {
      const updateQuestions = spyOn(instance, 'updateQuestions')
      instance.onCloseClick()
      expect(updateQuestions).toHaveBeenCalled()
    })
  })
  describe('#updateReplyList', () => {
    it('should call function', () => {
      const updateQuestions = spyOn(instance, 'updateQuestions')
      instance.updateReplyList(10, 3)
      expect(updateQuestions).toHaveBeenCalled()
      expect(wrapper.state('questions')[0].replies.length).toEqual(0)
      expect(wrapper.state('deleteReplyId')).toEqual(null)
    })
  })
  describe('#render', () => {
    it('should show the title', () => {
      expect(wrapper.state('questions').length).toEqual(1)
      expect(wrapper.find('Comment__Title').exists()).toBeTruthy()
    })
    it('should hide the title', () => {
      const questions = []
      wrapper.setState({ questions })
      expect(wrapper.state('questions').length).toEqual(0)
      expect(wrapper.find('Comment__Title').exists()).toBeFalsy()
    })
  })
})
